import Home from "./home";

export const Routing = [
    {
        to:'/home',
        level:0x1fff,
        component: <Home />
    },
    
]